import { modalRenderer } from '~/modal/modalRendererRegistry';
import { EmbedMapModalContainer } from './embedMapModal.container';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    EmbedMap: undefined;
  }
}
modalRenderer.register('EmbedMap', EmbedMapModalContainer);
